module.exports = __webpack_public_path__ + "static/media/officeImg1.1e44000a.png";